<template>
  <div class="row col-md-8 m-auto">
    <div class="supplier-importer col-md-9">
      <div class="supplier-importer-instructions">
        <h3>{{ $t("supplier.import") }}</h3>
        <p>{{ $t("supplier.importInstructions1") }}</p>
        <p>{{ $t("supplier.importInstructions2") }}</p>
        <p>
          <a href="/examples/supplier_examples.zip" download
            ><strong class="text-text-info-main link">{{ $t("supplier.downloadExample") }}</strong></a
          >
        </p>
      </div>
      <div class="row ml-1">
        <checkbox class="bring-checkbox" @check="overwrite = $event" :label="$t('supplier.overwrite')">
        </checkbox>
      </div>
      <div v-for="(c, key) in Object.keys(columns)" :key="key" class="row ml-1">
        <checkbox
          :isDisabled="!overwrite"
          :key="key"
          :propValue="columns[c]"
          @check="columns[c] = $event"
          :label="$t('supplier.' + c)"
        >
        </checkbox>
      </div>
      <div class="row">
        <div class="col mt-2">
          <label class="float-left">
            <span class="upload-button">{{ $t("supplier.selectFile") }}</span>
            <input :ref="'files'" type="file" @input="selectFile" />
            <span v-if="file">: {{ file.name }}</span>
          </label>
        </div>
        <div class="col">
          <button
            :disabled="!file || loading"
            @click="upload"
            class="btn btn-success float-right"
            style="min-width:13em;"
          >
            <template v-if="!loading">
              {{ $t("supplier.importSuppliers") }}
            </template>
            <template v-else>
              <div class="spinner-border spinner-border-sm"></div>
            </template>
          </button>
        </div>
      </div>
    </div>
    <div class="col-lg col-xl-3 d-flex align-items-start flex-column">
      <h3 style="align-self:center">{{ $t("supplier.importFromSystem") }}</h3>
      <p style="align-self:center">{{ $t("supplier.importInstructions3") }}</p>
      <p style="align-self:center" class="mb-auto">
        {{ $t("supplier.importInstructions4") }}
      </p>
      <button
        @click="$emit('import')"
        class="btn btn-success"
        :disabled="importing"
      >
        <template v-if="!importing">{{
          $t("supplier.importSuppliersFromSystem")
        }}</template>
        <template v-else>{{ $t("supplier.importingFromSystem") }}</template>
      </button>
    </div>
  </div>
</template>

<script>
import Checkbox from "../common/Checkbox";
export default {
  props: ["importing"],
  data() {
    return {
      overwrite: false,
      file: null,
      loading: false,
      columns: {
        name: false,
        street1: false,
        street2: false,
        postOffice: false,
        postalCode: false,
        countryCode: false,
        email: false,
        language: false
      },
      publicPath: process.env.BASE_URL
    };
  },
  methods: {
    import: function() {
      if (!this.importing) {
        this.$emit("import");
      }
    },
    selectFile: function(e) {
      if (e.target.files) {
        this.file = e.target.files[0];
      } else {
        this.file = null;
        this.$refs.files.value = "";
      }
    },
    upload: async function(e) {
      try {
        if (this.file) {
          let file = this.file;
          if (
            file.type === "text/csv" ||
            file.type ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
            file.type === "application/vnd.ms-excel"
          ) {
            this.loading = true
            let formData = new FormData();
            formData.append("file", file);
            formData.append(
              "filetype",
              file.type === "text/csv" ? "csv" : "excel"
            );
            if (!this.overwrite) {
              let res = await this.$store.dispatch("uploadSuppliers", formData);
              if (res.added.length > 0) {
                this.$emit("updateList");
                this.$notify({
                  type: "success",
                  text: this.$t("supplier.addedSuppliers", {
                    count: res.added.length
                  }),
                  duration: 3000
                });
              }
              if (res.duplicates.length > 0) {
                this.$notify({
                  type: "error",
                  text: this.$t("supplier.duplicates", {
                    count: res.duplicates.length
                  }),
                  duration: 3000
                });
              }
            } else {
              formData.append("overWriteColumns", JSON.stringify(this.columns));
              let res = await this.$store.dispatch(
                "uploadSuppliersOverwrite",
                formData
              );
              res.added.forEach(s => {
                this.$emit("updateSupplier", s);
              });
              this.$notify({
                type: "success",
                text: this.$t("supplier.updatedSuppliers", {
                  count: res.added.length
                }),
                duration: 3000
              });
            }
          } else {
            this.$notify({
              type: "error",
              text: this.$t("supplier.errorFileType"),
              duration: 3000
            });
          }
        }
        this.$refs.files.value = "";
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "error",
          text: this.$t("supplier.operationFailed"),
          duration: 3000
        });
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    overwrite: function(val) {
      this.columns.name = false;
      this.columns.street1 = false;
      this.columns.street2 = false;
      this.columns.postOffice = false;
      this.columns.postalCode = false;
      this.columns.countryCode = false;
      this.columns.email = false;
      this.columns.language = false;
    }
  },
  components: {
    Checkbox
  }
};
</script>

<style scoped>
.supplier-importer {
  border-right: 2px dashed #006366;
  margin-top: 10px;
  padding: 0 10px;
  max-width: 1000px;
}
input[type="file"] {
  display: none;
}
.bring-checkbox {
  accent-color: #006366;
}

input[type="checkbox"] {
  accent-color: #006366;
}
.checkmark {
  background-color: #006366;
}
.ckmark-container{
  color: #0B0B14;
}
.upload-button {
  color: #004A4D;
  cursor: pointer;
  text-decoration: underline;
}
.upload-button:hover {
  text-decoration: underline;
}
.supplier-importer-instructions > p {
  margin-bottom: 0.5rem;
}
@media screen and (max-width: 950px) {
  .supplier-importer {
    border-left: none;
    margin-top: 0;
    padding: 10px;
  }
}
</style>
